import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation files
const resources = {
  en: {
    translation: {
      "title": "The Ultimate Artificial Intelligence Tools Directory",
      "subtitle": "Discover, compare and organize the best AI solutions to boost your productivity. From text generation with ChatGPT to image creation via Midjourney, find the perfect tool for your needs.",
      "hero_h2": "Find the right AI for your project",
      "hero_desc": "Our directory lists the most powerful Artificial Intelligence tools on the market, categorized by: Text, Image, Video, Code and Audio. Whether you are a developer, content creator or creative, optimize your workflow with AI automation and generation.",
      "search_placeholder": "Search for a tool...",
      "categories": {
        "all": "All",
        "favorites": "Favorites",
        "text": "Text",
        "image": "Image",
        "video": "Video",
        "code": "Code",
        "other": "Other"
      },
      "sort_by": "Sort by:",
      "sort_name": "Name (A-Z)",
      "sort_popularity": "Popularity (Clicks)",
      "clicks": "clicks",
      "tool": {
        "pricing": "Pricing",
        "version": "Version",
        "visit": "Visit Official Website",
        "discover": "Details",
        "description": "Description",
        "info": "Information"
      },
      "created_by": "Created by",
      "total_visits": "Total Visits",
      "activity_chart": "Activity (Last 7 days)",
      "no_stats": "No statistics yet for this tool.",
      "not_found": "Tool not found",
      "back_home": "Back",
      "footer_about_title": "About",
      "footer_about_text": "AI Directory is your companion for navigating the ever-evolving AI ecosystem.",
      "footer_contact_title": "Contact",
      "footer_rights": "All rights reserved."
    }
  },
  fr: {
    translation: {
      "title": "L'Annuaire Ultime des Outils d'Intelligence Artificielle",
      "subtitle": "Découvrez, comparez et organisez les meilleures solutions IA pour booster votre productivité. De la génération de texte avec ChatGPT à la création d'images via Midjourney, trouvez l'outil parfait pour vos besoins.",
      "hero_h2": "Trouvez la bonne IA pour votre projet",
      "hero_desc": "Notre annuaire répertorie les outils d'Intelligence Artificielle les plus puissants du marché, classés par : Texte, Image, Vidéo, Code et Audio. Que vous soyez développeur, créateur de contenu ou créatif, optimisez votre flux de travail grâce à l'automatisation et à la génération par IA.",
      "search_placeholder": "Rechercher un outil...",
      "categories": {
        "all": "Tous",
        "favorites": "Favoris",
        "text": "Texte",
        "image": "Image",
        "video": "Vidéo",
        "code": "Code",
        "other": "Autre"
      },
      "sort_by": "Trier par :",
      "sort_name": "Nom (A-Z)",
      "sort_popularity": "Popularité (Clics)",
      "clicks": "clics",
      "tool": {
        "pricing": "Tarifs",
        "version": "Version",
        "visit": "Visiter le site officiel",
        "discover": "Détails",
        "description": "Description",
        "info": "Informations"
      },
      "created_by": "Créé par",
      "total_visits": "Total des visites",
      "activity_chart": "Activité (7 derniers jours)",
      "no_stats": "Aucune statistique pour cet outil moment.",
      "not_found": "Outil non trouvé",
      "back_home": "Retour",
      "footer_about_title": "À propos",
      "footer_about_text": "L'Annuaire IA est votre compagnon pour naviguer dans l'écosystème de l'IA en constante évolution.",
      "footer_contact_title": "Contact",
      "footer_rights": "Tous droits réservés."
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // react already safes from xss
    }
  });

export default i18n;
